import React from "react";
import CcFilterChip from "./CcFilterChip";
import { cx } from "../utils";

/**
 * CcFilterChipRow — horizontal filter chip group (status left, severity right).
 */
const CcFilterChipRow = ({
  chips = [],
  activeKey,
  activeKeys,
  multiple = false,
  /** When set with `multiple`, this chip is active only when `activeKeys` is empty (mutually exclusive with others). */
  allKey = null,
  onChange,
  className,
  align = "start",
}) => {
  const isChipActive = (chipKey) => {
    if (multiple) {
      if (allKey && chipKey === allKey) {
        return !activeKeys?.length;
      }
      return Array.isArray(activeKeys) && activeKeys.includes(chipKey);
    }
    return activeKey === chipKey;
  };

  return (
    <div
      className={cx(
        "cc-filter-chip-row",
        align === "end" && "cc-filter-chip-row--end",
        className,
      )}
      role={multiple ? "group" : "tablist"}
    >
      {chips.map((chip) => (
        <CcFilterChip
          key={chip.key}
          label={chip.label}
          count={chip.count}
          variant={chip.variant || "neutral"}
          showDot={chip.showDot}
          active={isChipActive(chip.key)}
          onClick={() => onChange?.(chip.key, chip)}
          aria-pressed={multiple ? isChipActive(chip.key) : undefined}
        />
      ))}
    </div>
  );
};

export default CcFilterChipRow;
